import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

import Navbar from './components/Navbar';
import Home from './pages/Home';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import DigitalTransformation from './pages/DigitalTransformation';
import VoipAsterisk from './pages/services/voip/VoipAsterisk';
import ServerLinux from './pages/services/infrastructure/ServerLinux';
import ServerWindows from './pages/services/infrastructure/ServerWindows';
import Docker from './pages/services/infrastructure/Docker';
import Kubernetes from './pages/services/infrastructure/Kubernetes';
import Proxmox from './pages/services/infrastructure/Proxmox';
import ServerAdministration from './pages/services/infrastructure/ServerAdministration';
import DatabaseMySQL from './pages/services/infrastructure/DatabaseMySQL';
import DatabasePostgreSQL from './pages/services/infrastructure/DatabasePostgreSQL';
import Odoo from './pages/services/development/Odoo';
import CloudSolutions from './pages/services/infrastructure/CloudSolutions';
import EcommerceSolutions from './pages/services/development/EcommerceSolutions';
import SviluppoWebFrontend from './pages/services/development/SviluppoWebFrontend';
import SviluppoBackend from './pages/services/development/SviluppoBackend';
import MobileAppDevelopment from './pages/services/development/MobileAppDevelopment';
import UIUXDesign from './pages/services/development/UIUXDesign';
import ConsulenzaTecnica from './pages/services/consulting/ConsulenzaTecnica';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';

function App() {
    return (
        <Router>
            <div className="App">
                <Navbar />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/service/:id" element={<ServiceDetail />} />
                    <Route path="/services/voip/voip-asterisk" element={<VoipAsterisk />} />
                    <Route path="/services/infrastructure/server-linux" element={<ServerLinux />} />
                    <Route path="/services/infrastructure/server-windows" element={<ServerWindows />} />
                    <Route path="/services/infrastructure/docker" element={<Docker />} />
                    <Route path="/services/infrastructure/kubernetes" element={<Kubernetes />} />
                    <Route path="/services/infrastructure/proxmox" element={<Proxmox />} />
                    <Route path="/services/infrastructure/server-administration" element={<ServerAdministration />} />
                    <Route path="/services/infrastructure/database-mysql" element={<DatabaseMySQL />} />
                    <Route path="/services/infrastructure/database-postgresql" element={<DatabasePostgreSQL />} />
                    <Route path="/services/development/odoo" element={<Odoo />} />
                    <Route path="/services/infrastructure/cloud-solutions" element={<CloudSolutions />} />
                    <Route path="/services/development/e-commerce-solutions" element={<EcommerceSolutions />} />
                    <Route path="/services/development/sviluppo-web-frontend" element={<SviluppoWebFrontend />} />
                    <Route path="/services/development/sviluppo-backend" element={<SviluppoBackend />} />
                    <Route path="/services/development/mobile-app-development" element={<MobileAppDevelopment />} />
                    <Route path="/services/development/ui-ux-design" element={<UIUXDesign />} />
                    <Route path="/services/consulting/consulenza-tecnica" element={<ConsulenzaTecnica />} />
                    <Route path="/services/development/:slug" element={<ServiceDetail />} />
                    <Route path="/services/infrastructure/:slug" element={<ServiceDetail />} />
                    <Route path="/services/voip/:slug" element={<ServiceDetail />} />
                    <Route path="/services/consulting/:slug" element={<ServiceDetail />} />
                    <Route path="/digital-transformation" element={<DigitalTransformation />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/terms-of-service" element={<TermsOfService />} />
                </Routes>
                <Footer />
                <CookieBanner />
            </div>
        </Router>
    );
}

export default App;